import React, { useState } from "react";
import RecurringModal from "./recurring/RecurringModal";
import { ICreateSalesData } from "../../../@types";

interface Props {
  formData: ICreateSalesData;
  setFormData: React.Dispatch<React.SetStateAction<ICreateSalesData>>;
}
const RecurringSection: React.FC<Props> = ({ formData, setFormData }) => {
  const [toggleRecurring, setToggleRecurring] = React.useState(false);
  const [openModal, setOpenModal] = useState(false);
  const handleToggleRecurring = () => {
    if (formData.isReoccurring) {
      setFormData((prev) => ({
        ...prev,
        isReoccurringEndDate: undefined,
        reoccurringGroupName: undefined,
        shouldSendEmail: undefined,
        shouldSendSMS: undefined,
        isReoccurring: false,
      }));
      return;
    }
    setToggleRecurring(!toggleRecurring);
    setOpenModal(!openModal);
  };

  return (
    <>
      <div className="border-gray-200 border-[1px] mt-5 md:w-[350px] w-full rounded-md ">
        <div className="flex justify-between items-center py-3 w-full px-2">
          <p className="text-[14px] font-medium leading-5 mb-1">
            Set as recurring invoice
          </p>
          <div
            onClick={handleToggleRecurring}
            className={`w-12 h-6 p-1 rounded-[69.33px] flex items-center transition duration-200 ease-in cursor-pointer ${
              formData?.isReoccurring
                ? "bg-[#044E97] justify-end border-[#044E97]"
                : "bg-[#ffffff] justify-start border border-gray-300"
            }`}
            style={{ borderWidth: "1px" }}
          >
            <div
              className={`w-4 h-4 rounded-full shadow-md transition-transform duration-200 ease-in ${
                toggleRecurring ? "bg-[#ffffff]" : "bg-[#D1D5DB]"
              }`}
            />
          </div>
        </div>
        {formData?.isReoccurring && (
          <div className="border-t-[1px] border-gray-200 px-2">
            <div className="flex justify-between items-center my-2">
              <h1 className="text-[#044E97] text-[14px] font-medium leading-5">
                End Date
              </h1>
              {formData.isReoccurringEndDate ? (
                <h1 className="text-[14px] font-medium leading-5">
                  {new Date(formData.isReoccurringEndDate).toDateString()}
                </h1>
              ) : (
                <h1 className="text-[20px] font-medium leading-5 ">∞</h1>
              )}
            </div>
            <div className="flex justify-between items-center my-2">
              <h1 className="text-[#044E97] text-[14px] font-medium leading-5">
                Frequency
              </h1>
              <h1 className="text-[14px] font-medium leading-5 capitalize">
                {formData?.reoccurringGroupName}
              </h1>
            </div>
            {(formData.shouldSendEmail || formData.shouldSendSMS) && (
              <div className="flex justify-between items-center my-2">
                <h1 className="text-[#044E97] text-[14px] font-medium leading-5">
                  Reminder Channel
                </h1>
                <h1 className="text-[14px] font-medium leading-5">
                  {formData.shouldSendEmail ? "Email" : "SMS"}
                </h1>
              </div>
            )}
            <div className="flex justify-end">
              <button
                onClick={() => setOpenModal(true)}
                className="text-[#044E97] text-medium text-sm cursor-pointer text-end my-3"
              >
                Edit
              </button>
            </div>
          </div>
        )}
      </div>
      {openModal && (
        <RecurringModal
          toggleRecurring={toggleRecurring}
          handleToggleRecurring={() => setOpenModal(!openModal)}
          formData={formData}
          setFormData={setFormData}
        />
      )}
    </>
  );
};

export default RecurringSection;
